module.exports = __webpack_public_path__ + "assets/normal-man.svg?v=715da0b54c52e23785821ed5dbab9d5c";